import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import Ad from '@ifeng-fe/ui_pc_ad';
import styles from './index.css';
import { classNames } from '../../utils/classnames';
import Logo from './logo';
import Nav from './nav';
import Footer from './footer';
import Action from './action';
import HotNews from './hotNews';
import Leaderboard from './leaderboard';
import HtmlRegion from '../../components/htmlRegion';
import ScrollDisplay from '../components/scrollDisplay';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;

        const logoData = {
            channel: content.channel,
            search: content.search,
            slogan: content.slogan,
            banner1: content.banner1,
        };
        const navData = content.nav;
        const actionData = {
            newsstream: content.newsstream,
            columnId: content.columnId,
            page: content.page,
            endPage: content.endPage,
        };
        const hotNewsData = {
            hotNewsTitle: content.hotNewsTitle,
            hotNews: content.hotNews,
        };

        return (
            <Fragment>
                <ChipEdit transform={transform} />
                <Ad styleName={styles.headAd} content={content.headAd} />
                <Logo content={logoData} />
                <Nav content={navData} />
                <div className={classNames(styles.main, 'clearfix')}>
                    <Action content={actionData} />
                    <div className={styles.aside}>
                        <HotNews content={hotNewsData} />
                        <Leaderboard content={content.sevenDayClickRanking} />
                        <Chip id="30025" type="static" title="二维码" groupName="二维码" content={content.qrcode}>
                            <HtmlRegion className={styles.qrcode} />
                        </Chip>
                    </div>
                </div>
                <Footer content={content.footer} />
                <ScrollDisplay>
                    <Chip id="30023" type="static" title="二维码" groupName="二维码" content={content.floatQrcode}>
                        <HtmlRegion />
                    </Chip>
                </ScrollDisplay>
            </Fragment>
        );
    }
}

export default Layout;
